import { AutogenModelChargeCodeEdi, AutogenRowChargeCodeEdi } from "./autogen/AutogenModelChargeCodeEdi";

export class ModelChargeCodeEdi extends AutogenModelChargeCodeEdi<RowChargeCodeEdi> {
	constructor() {
		super(RowChargeCodeEdi);
	}
}

export class RowChargeCodeEdi extends AutogenRowChargeCodeEdi {
}